import Joi from 'joi';

/**
 * Schema for renewed billable event validation.
 */
export const renewBillableEventsSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
